<template>
  <div>
      <el-table
        :data="invoices"
        stripe
        :height="height"
        :empty-text="$t('invoices.noInvoices')"
        style="width: 100%;"
        :default-sort="{ prop: sortProp, order: sortOrder }"
        @sort-change="handleSortChange"
        :cell-style="{padding:'2px'}">
        <el-table-column
          width="50">
          <template slot-scope="scope">

            <status-indicator class="ml-10"
              :positive="isPositive(scope.row)"
              :intermediary="isIntermediary(scope.row)"
              :negative="isNegative(scope.row)"
              pulse
            />

          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.number')"
          prop="inv_number"
          fixed
          sortable="custom"
          v-if="showField('inv_number')"
          width="150">
          <template slot-scope="scope">
            <PortausLink path="/invoices/" :id="scope.row.id" :label="scope.row.inv_number" fs="fs-12"></PortausLink>
          </template>
        </el-table-column>
        <el-table-column
          prop="customer.name"
          sortable="custom"
          v-if="showField('customer')"
          :label="$t('common.customer')">
          <template slot-scope="scope">
            <PortausLink path="/customers/" :id="scope.row.customer.id" :label="customerName(scope.row.customer)" fs="fs-12"></PortausLink>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showField('date')"
          :label="$t('common.date')"
          prop="date"
          sortable="custom"
          width="150">
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.date">{{_moment(scope.row.date)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.dueDate')"
          prop="due_date"
          v-if="showField('due_date')"
          sortable="custom"
          width="150">
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.due_date">{{_moment(scope.row.due_date)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          :label="$t('common.amount')"
          v-if="showField('amount')"
          sortable="custom"
          width="150">
          <template slot-scope="scope">
            <span style="word-break: break-word;">{{$n(scope.row.total,'currency', scope.row.currency.code)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showField('payment')"
          :label="$t('common.payment')"
          sortable>
          <template slot-scope="scope">
            <div v-for="payment in scope.row.payments" :key=payment.id>
              <span style="work-break:break-word;">{{paymentType(payment)}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showField('paid_at')"
          :label="$t('invoices.paidAt')"
          sortable>
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.paid_at">{{_moment(scope.row.paid_at)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status.code"
          v-if="showField('status')"
          :label="$t('common.status')"
          sortable="custom">
          <template slot-scope="scope">
            <el-tag  style="margin-left:10px;" size="small">{{$t("invoices.statuses."+scope.row.status.code)}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>
<script>
import moment from 'moment-business-days'
import InvoiceTile from '@/components/invoice/Invoice-tile'
import PortausLink from '@/components/portaus-link'

export default {
  name: 'invoice-table',
	props: {
    invoices : Array,
    height : {
      type : [String, Number],
      default : "250"
    },
    filters : Array,
    criterias : Array,
    fields : Array,
    sortProp: {
      type: String,
      default: 'date'
    },
    sortOrder: {
      type: String,
      default: 'ascending'
    }
	},
  data() {
    return {
      loading : false,
    };
  },components: {
    InvoiceTile,
    PortausLink
  },
  watch : {

  },
	methods: {
    paymentType(payment){
      return this.$i18n.t("invoices."+payment.payment_type.code);

    },
    customerName(customer){
      return customer.usual_name!=null && customer.usual_name!=''?customer.usual_name:customer.name;
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

    },
    date(so){
      if(this.filters){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        return status.status_log.created_at;
      }else{
        return so.date;
      }

    },
    isPositive(inv){
      // if(inv.status.code!="DRAFT"){
      //   return (!this.isNegative(inv) && !this.isIntermediary(inv))
      // }
      // return false;
      return false;
    },
    isNegative(so){
      // if(so.status.code=="CONFIRMED"){
      //   //processDate = a la date que la commande doit être passée
      //   var processDate = moment(so.expected_delivery_date).startOf('day').businessSubtract(2)._d;
      //
      //   //Si la date de la commande est aujourd'hui
      //   if(moment(processDate).isSame(moment(), 'day')){
      //     if(so.delivery_type!=null && so.delivery_type.code==="CUSTOMER_DELIVERY_9H"){
      //       return moment(new Date()).hours()>=9;
      //     }else if(so.delivery_type!=null && so.delivery_type.code==="CUSTOMER_DELIVERY_16H"){
      //       return moment(new Date()).hours()>=16;
      //     }
      //   }else if(moment(processDate).isBefore(moment(), 'day')){
      //     //Si la date de la commande est passé
      //     return true;
      //   }
      // }

      return false;
    },isIntermediary(so){
      // if(so.status.code=="CONFIRMED"){
      //   //processDate = a la date que la commande doit être passée
      //   var processDate = moment(so.expected_delivery_date).startOf('day').businessSubtract(2)._d;
      //
      //   //Si la date de la commande est aujourd'hui
      //   if(moment(processDate).isSame(moment(), 'day')){
      //     if(so.delivery_type!=null && so.delivery_type.code==="CUSTOMER_DELIVERY_9H"){
      //       return moment(new Date()).hours()<9;
      //     }else if(so.delivery_type!=null && so.delivery_type.code==="CUSTOMER_DELIVERY_16H"){
      //       return moment(new Date()).hours()<16;
      //     }
      //   }
      // }

      return false;
    },
    openInvoice(invoiceId){
      var index='/invoices/'+invoiceId;
      this.$router.push(index);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
      this.$router.push(index);
    },
    showField(field){
      const fields = _.isEmpty(this.fields)
        ? ['inv_number', 'customer', 'due_date', 'amount', 'status']
        : this.fields;
      let fieldFound = _.find(fields, f=>{return f==field})
      return fieldFound!=null;
    },
    handleSortChange({ prop, order }) {
      this.$emit('sort-change', { prop, order });
    }
	},
	computed: {
    isFilterByDate(){
      let filterByDate = _.find(this.criterias, c=>{return c.code=='date'})
      return filterByDate!=null;
    }

	}
}
</script>
<style lang="scss" scoped>




</style>
